(function() {
  'use strict';

  function AsyncTasksSearch(
    $q,
    $filter,
    $translate,
    moment,
    Cache
  ) {
    var PLACEHOLDER = $translate.instant('Start typing to search...');

    var getAsyncTasksSearch = function(options) {
      // merge all defaultFilters
      var defaultFilter = {};
      options = _.isObject(options) ? options : {};
      defaultFilter = _.assignIn({}, defaultFilter || {}, (options.defaultFilter || {}).filter);

      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              label: $translate.instant('Start typing to search'),
              facetly: true,
              advanced: false
            },
            {
              id: 'action',
              type: 'select',
              label: $translate.instant('Action'),
              multiselect: false,
              options: [
                { id: 'import_file', title: $translate.instant('CSV import') }
              ],
              facetly: false,
              advanced: false
            },
            {
              id: 'state',
              type: 'select',
              label: $translate.instant('State'),
              multiselect: true,
              options: [
                { id: 'new', title: $translate.instant('New') },
                { id: 'processing', title: $translate.instant('Processing') },
                { id: 'success', title: $translate.instant('Success') },
                { id: 'failure', title: $translate.instant('Failure') },
                { id: 'aborted', title: $translate.instant('Aborted') }
              ],
              facetly: false,
              advanced: true
            },
            {
              id: 'createdDate_start',
              type: 'date',
              label: $translate.instant('Created date from'),
              facetly: false,
              advanced: true
            },
            {
              id: 'createdDate_end',
              type: 'date',
              label: $translate.instant('Created date to'),
              facetly: false,
              advanced: true
            }
          ],
          options: {
            defaultFacet: 'name',
            placeholder: PLACEHOLDER,
            listMaxItems: 200
          }
        },
        filters: [
          {
            id: 'action',
            matchFunc: function(item, _key, value) {
              var celeryTask = item.main || item;
              return value.indexOf(celeryTask.doc.action) === -1;
            }
          },
          {
            id: 'state',
            matchFunc: function(item, _key, value) {
              var celeryTask = item.main || item;
              return value.indexOf(celeryTask.doc.state) === -1;
            }
          }
        ],
        orders: {
          addedDate: function(item) {
            var celeryTask = item.main || item;
            var date = celeryTask.doc.createdDate;
            if (date) {
              return -(moment(date).toDate().getTime());
            }

            return Number.MIN_SAFE_INTEGER;
          }
        },
        orderGroups: {
          addedDate: {
            title: $translate.instant('date added'),
            orders: ['addedDate'],
            groupBy: {
              title: $translate.instant('Task created in'),
              notitle: $translate.instant('Task without a date'),
              getter: function(item) {
                var celeryTask = item.main || item;
                var date = celeryTask.createdDate;
                if (date) {
                  return $filter('date')(date, 'MMMM y');
                }

                return;
              }
            }
          }
        },
        defaultFilter: defaultFilter,
        defaultOrder: 'addedDate'
      };

      search.ready = false;
      return $q.when(search);
    };

    var searches = { search: getAsyncTasksSearch };

    var getSearch = function(searchType) {
      var func = searches[searchType];
      if (func === undefined) {
        return $q.reject({ status: 500, message: 'An unknown search type: ' + searchType });
      }

      var ext = _.assignIn({
        key: 'search-async-' + searchType,
        maxAge: 60 * 60 * 1000,
        cached: true
      });
      return Cache.cachedPromise(func, ext);
    };

    var service = { getSearch: getSearch };

    return service;
  }

  AsyncTasksSearch.$inject = [
    '$q',
    '$filter',
    '$translate',
    'moment',
    'CacheService'
  ];

  angular.module('blocks.asyncTasks')
    .service('AsyncTasksSearch', AsyncTasksSearch);
})();
